<template>
  <b-row>
    <b-col>
      <b-card>
        <h5>
          <strong>Crear deducción</strong>
        </h5>
        <ValidationObserver ref="observer">
          <b-form @submit.prevent="saveDeduction" ref="formCreateDeduction">
            <b-row class="pt-4">
              <b-col lg="4">
                <validation-provider name="tipo de deduccion" :rules="{ required: true }" v-slot="validationContext">
                  <b-form-group id="input-group-company1" label="Tipo de deducción:" label-for="input-company1"
                    :invalid-feedback="validationContext.errors[0]">
                    <b-form-select id="input-company1" v-model="form.idConceptType" :options="typesDeductions" required
                      :state="getValidationState(validationContext)"></b-form-select>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="4">
                <validation-provider name="nombre" :rules="{ required: false }" v-slot="validationContext">
                  <b-form-group id="input-group-company2" label="Nombre:" label-for="input-company2"
                    :invalid-feedback="validationContext.errors[0]">
                    <b-form-input id="input-company2" v-model="form.name" autocomplete="shut-up-google"
                      :state="getValidationState(validationContext)"
                      placeholder="Ingrese el nombre de la deducción"></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="4" class="mt-3">
                <b-button variant="primary" type="submit" class="mr-2 mb-3 mt-3">Guardar cambios</b-button>
              </b-col>
            </b-row>
            <a-divider />
          </b-form>
          <b-row>
            <b-col>
              <h5 class="mb-4">
                <strong>Lista de deducciones</strong>
              </h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table id="table-deductions" striped hover :fields="columns" head-variant="light" :items="deductionList"
                :per-page="pagination.perPage" :current-page="pagination.currentPage" v-if="deductionList.length > 0"
                responsive>
                <template #cell(name)="element">
                  {{ element.item['conceptType.name'] + ' ' + ((element.item.name) ? ' (' + element.item.name + ')' : '') }}
                </template>
                <template #cell(state)="element">
                  <b-badge v-if="element.item.state" pill variant="success">Activo</b-badge>
                  <b-badge v-if="!element.item.state" pill variant="danger">Inactivo</b-badge>
                </template>
                <template #cell(actions)="element">
                  <span v-if="element.item.idSchool === null">
                    <button type="button" disabled v-on:click.prevent="() => { console.log('adsf') }"
                      class="btn btn-light mr-2" data-toggle="tooltip" data-placement="top" title="Editar">
                      <i class="fa fa-pencil text-blue" />
                    </button>
                    <button type="button" disabled v-on:click.prevent="() => { console.log('adsf') }"
                      class="btn btn-light mr-2" data-toggle="tooltip" data-placement="top" title="Eliminar">
                      <i class="fa fa-trash text-red" />
                    </button>
                  </span>
                  <span v-else>
                    <button type="button" v-on:click="openModalEditDeduction(element.item)" class="btn btn-light mr-2"
                      data-toggle="tooltip" data-placement="top" title="Editar">
                      <i class="fa fa-pencil text-blue" />
                    </button>
                    <button type="button" v-on:click="deleteDeduction(element.item)" class="btn btn-light mr-2"
                      data-toggle="tooltip" data-placement="top" title="Eliminar">
                      <i class="fa fa-trash text-red" />
                    </button>
                  </span>
                </template>
              </b-table>
              <empty-table v-else />
              <b-row>
                <b-col>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.rows"
                    :per-page="pagination.perPage" aria-controls="table-deductions"></b-pagination>
                </b-col>
                <b-col>
                  <b-button v-on:click="$emit('set-config', 0)" class="btn btn-light pull-right" variant="light">
                    Ir atrás
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </ValidationObserver>
      </b-card>
      <b-modal id="edit-deduction" ref="modal" title="Editar devengado" hide-footer>
        <b-form @submit="editDeduction" ref="editDeduction">
          <b-form-group label="Nombre:" label-for="name">
            <b-form-input v-model="deductionToEdit.name" placeholder="Ingrese el nombre de la deducción"></b-form-input>
          </b-form-group>
          <b-form-group label="Estado:" label-for="estado">
            <b-form-checkbox id="state" v-model="deductionToEdit.state" name="state">
              Activo
            </b-form-checkbox>
          </b-form-group>
          <b-button @click="$bvModal.hide('edit-deduction')" variant="secondary" size="sm"
            class="mr-2 mb-3 mt-3">Cancelar</b-button>
          <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
        </b-form>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import apiClient2 from '@/services/axios/v2.js'
import emptyTable from '@/components/custom/cardEmptyList'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'deductionSettings',
  components: {
    emptyTable,
  },
  data() {
    return {
      typesDeductions: [],
      invalid: false,
      form: {
        name: '',
        idConceptType: null,
      },
      deductionList: [],
      columns: [
        { key: 'name', label: 'Deducción' },
        { key: 'state', label: 'Estado' },
        { key: 'actions', label: 'Acciones' },
      ],
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      deductionToEdit: {
        name: '',
        state: true,
        id: '',
        'conceptType.name': '',
      },
    }
  },
  computed: {
    ...mapState(['user']),
  },
  created () {
    this.getDeductions()
      .then(() => this.getTypeDeductions())
      .then(() => {
      })
      .catch((error) => {
        console.error('Ha ocurrido un error:', error)
      })
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    getDeductions() {
      return new Promise((resolve, reject) => {
        apiClient2.get('/concepts', {
          params: {
            conceptType: 'deduction',
          },
        })
          .then((response) => {
            const { data } = response.data
            this.deductionList = Array.isArray(data) ? data : []
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getTypeDeductions() {
      return new Promise((resolve, reject) => {
        apiClient2.get('/type-concepts', {
          params: {
            conceptType: 'deduction',
          },
        })
          .then((response) => {
            const { data } = response.data
            if (Array.isArray(data)) {
              data.forEach((typeDeduction) => {
                // Deducciones que no se pueden crear más de una vez
                if (typeDeduction.isRecreate === false) {
                  const deduction = this.deductionList.find((a) => a.idConceptType === typeDeduction.id)
                  if (!deduction) {
                    this.typesDeductions.push({
                      value: typeDeduction.id,
                      text: typeDeduction.name,
                    })
                  }
                } else {
                  // Deducciones que se pueden crear más de una vez
                  this.typesDeductions.push({
                    value: typeDeduction.id,
                    text: typeDeduction.name,
                  })
                }
              })
            }
            this.typesDeductions.unshift({ value: null, text: 'Seleccione una opción' })
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    async saveDeduction() {
      const isValid = await this.$refs.observer.validate()
      // Si no es válido el formulario no pasa
      if (isValid) {
        apiClient2.post('/concepts', this.form).then(response => {
          this.deductionList.push(response.data.data)
          // Reset form
          this.resetForm()
          // Clean type accrual list of select
          if (response.data.data['conceptType.isRecreate'] === false) {
            this.typesDeductions = this.typesDeductions.filter((typeDeduction) => typeDeduction.value !== response.data.data.idConceptType)
          }
          this.$notification.success({
            message: 'Deducción creada',
            description: response.data.message,
          })
        })
      } else {
        this.$notification.warning({
          message: 'Deducción no fue creada',
          description: 'Error al crear la deducción, comunicate con soporte técnico.',
        })
      }
    },
    async resetForm() {
      this.form.idConceptType = null
      this.form.name = ''
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    openModalEditDeduction(deduction) {
      const cloneDeduction = { ...deduction }
      this.deductionToEdit.name = cloneDeduction.name
      this.deductionToEdit.state = cloneDeduction.state
      this.deductionToEdit.id = cloneDeduction.id
      this.deductionToEdit.idConceptType = cloneDeduction.idConceptType
      this.deductionToEdit['conceptType.name'] = cloneDeduction['conceptType.name']
      this.$bvModal.show('edit-deduction')
    },
    editDeduction(evt) {
      evt.preventDefault()
      apiClient2.put(`/concepts/${this.deductionToEdit.id}`, {
        state: this.deductionToEdit.state,
        name: this.deductionToEdit.name,
      }).then((response) => {
        this.deductionList = this.deductionList.map(x => (x.id === this.deductionToEdit.id) ? this.deductionToEdit : x)
        this.$notification.success({
          message: 'Modificación exitosa',
          description: `Deducción ${this.deductionToEdit['conceptType.name']} actualizada exitosamente`,
        })
        this.deductionToEdit = {}
        this.$bvModal.hide('edit-deduction')
      })
    },
    deleteDeduction(deduction) {
      console.log('entre en delete')
      console.log(deduction)
      this.getTotalPayrollsByIdDeduction(deduction.id).then((data) => {
        const message = `<p style="margin:0">Se encontraron <b>${data.totalPayrolls}</b> nóminas registradas con esta deducción</p>`
        Swal.fire({
          title: 'Confirmar eliminación',
          html: `
              <div>
                <p style="margin:0">¿Estás seguro de eliminar la deducción <b>${deduction['conceptType.name']}</b>?</p>
                ${data.totalPayrolls > 0 ? message : ''}
                <span style="color:gray; font-size:11px">Nota: Si quieres que no te aparezca en la plantilla excel desactivalo en el bóton editar.</span>
              </div>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, eliminar',
          cancelButtonText: 'No',
        }).then(async (result) => {
          if (result.isConfirmed) {
            apiClient2.delete(`/concepts/${deduction.id}`).then(response => {
              this.deductionList = this.deductionList.filter(item => item.id !== deduction.id)
              // Add typeDeduction to typeDeductionList
              if (!(this.typesDeductions.find((td) => td.value === deduction.idConceptType))) {
                this.typesDeductions.push({
                  text: deduction['conceptType.name'],
                  value: deduction.idConceptType,
                })
                // Sort alphabetically
                this.typesDeductions.sort((a, b) => {
                  const typeDeductionNameA = a.text.toLowerCase()
                  const typeDeductionNameB = b.text.toLowerCase()
                  if (typeDeductionNameA < typeDeductionNameB) {
                    return -1
                  }
                  if (typeDeductionNameA > typeDeductionNameB) {
                    return 1
                  }
                  return 0
                })
              }
              Toast.fire({
                icon: 'success',
                title: `Deducción ${deduction['conceptType.name']} eliminado correctamente`,
              })
            }).catch(e => { console.log(e) })
          }
        })
      }).catch(e => { console.log(e) })
    },
    getTotalPayrollsByIdDeduction(idDeduction) {
      return new Promise((resolve, reject) => {
        apiClient2.get(`/concepts/${idDeduction}/payrolls`)
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  watch: {
    deductionList: function(value) {
      this.pagination.rows = value.length
    },
  },
}
</script>
